import { RouterModule, Routes } from "@angular/router";

import {
    SettingsFilesCategoryComponent,
    SettingsGeneralComponent,
    SettingsMappingComponent,
    SettingsUserEditManagerComponent,
    SettingsMainComponent,
    SettingsDashboardManagementComponent,
} from "@app/settings-components";
import { ActiveViewComponent, NotStartedComponent, CompletedViewComponent, ViewComponent, AssigneesViewComponent } from "@app/view-components";
import { AccessDeniedComponent } from "./access-denied/access-denied.component";
import { AccessUnauthorizedComponent } from "./access-unauthorized/access-unauthorized.component";
import { CardModalComponent } from "./card-modal-component/card-modal-component";
import { DevToolsComponent } from "./dev-tools/dev-tools.component";
import { AuditTrailComponent } from "./settings/audit-trail/audit-trail.component";
import {
    authGuard,
    cardAvailabilityGuard,
    cardIdGuard,
    dashboardIdGuard,
    dashboardManagementGuard,
    roleGuard,
    nonJobsGuard,
    dashboardRedirectGuard,
} from "@shared/index";
import { UnauthorizedRouteComponent } from "./unauthorized-route/unauthorized-route.component";
import { AllViewContainerComponent } from "./view-components/all-view-container/";

const appRoutes: Routes = [
    {
        path: "card-view",
        canActivate: [authGuard],
        component: ViewComponent,
        children: [
            {
                path: "",
                canActivate: [dashboardRedirectGuard],
                children: [],
            },
            {
                path: ":dashboardId",
                canActivate: [dashboardIdGuard],
                children: [
                    {
                        path: "find",
                        component: ActiveViewComponent,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardIdGuard],
                                component: CardModalComponent,
                            },
                        ],
                    },
                    {
                        path: "active",
                        component: ActiveViewComponent,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                component: CardModalComponent,
                            },
                        ],
                    },
                    {
                        path: "not-started",
                        component: NotStartedComponent,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                component: CardModalComponent,
                            },
                        ],
                    },
                    {
                        path: "completed",
                        component: CompletedViewComponent,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                component: CardModalComponent,
                            },
                        ],
                    },
                    {
                        path: "all",
                        component: AllViewContainerComponent,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                component: CardModalComponent,
                            },
                        ],
                    },
                    {
                        path: "assignees-view",
                        component: AssigneesViewComponent,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                component: CardModalComponent,
                            },
                        ],
                    },
                    { path: "", redirectTo: "active", pathMatch: "full" },
                ],
            },
        ],
    },
    {
        path: "settings",
        canActivate: [authGuard],
        children: [
            {
                path: "",
                pathMatch: "full",
                redirectTo: "main",
            },
            {
                path: "main",
                component: SettingsMainComponent,
                canActivate: [dashboardManagementGuard],
                data: {
                    expectedRole: ["can_manage_general_settings"],
                },
            },
            {
                path: "general",
                component: SettingsGeneralComponent,
                canActivate: [dashboardManagementGuard],
                data: {
                    expectedRole: ["can_manage_general_settings"],
                },
            },
            {
                path: "mappingofstatuses",
                component: SettingsMappingComponent,
                canActivate: [dashboardManagementGuard],
                data: {
                    expectedRole: ["can_manage_general_settings"],
                },
            },
            {
                path: "dashboardmanagement",
                component: SettingsDashboardManagementComponent,
                canActivate: [dashboardManagementGuard],
                data: {
                    expectedRole: ["can_manage_dashboards_management_settings"],
                },
            },
            {
                path: "audittrail",
                component: AuditTrailComponent,
                canActivate: [dashboardManagementGuard],
                data: {
                    expectedRole: ["can_manage_general_settings"],
                },
            },
            {
                path: "categories",
                component: SettingsFilesCategoryComponent,
                canActivate: [dashboardManagementGuard, nonJobsGuard],
                data: {
                    expectedRole: ["can_manage_general_settings"],
                },
            },
            {
                path: "users/:userId",
                component: SettingsUserEditManagerComponent,
                canActivate: [roleGuard],
                data: {
                    expectedRole: ["can_manage_dashboards_management_settings"],
                },
            },
        ],
    },
    {
        path: "accessdenied",
        component: AccessDeniedComponent,
    },
    {
        path: "accessdenied/:lang",
        component: AccessDeniedComponent,
    },
    {
        path: "accessunauthorized",
        component: AccessUnauthorizedComponent,
    },
    {
        path: "accessunauthorized/:lang",
        component: AccessUnauthorizedComponent,
    },
    {
        path: "unauthorizedroute",
        component: UnauthorizedRouteComponent,
    },
    {
        path: "dev-tools",
        component: DevToolsComponent,
    },
    { path: "", redirectTo: "card-view", pathMatch: "full" },
    { path: "**", redirectTo: "card-view", pathMatch: "full" },
];

export const Routing = RouterModule.forRoot(appRoutes, {});
